import { reportChartLegend } from '../../utils/reportChartLegend';
import React from 'react';
import { Form, FormGroup, FormControl, Button } from 'react-bootstrap';
import config from '../../../config';
import { Chart, registerables } from 'chart.js';
import Select from 'react-select';
import moment from 'moment';
import utils from '../../utils';
import {
    getMonthlyTargetArrayForYear,
    loadMonthlyTargetsFromAccount,
    cacheMonthlyTargetsInLocalStorage,
    getCurrentMonthTarget,
    readCachedMonthlyTargets,
} from '../../utils/monthlyTargets';

//Chart.register(...registerables);

class MonthlyProductivityReport extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            target: 0,
            monthTargets: [],
            selectedYear: moment().year(),
            years: [],
            selectedMachine: [],
            selectedCategory: 99,
            machineStr: '',
            originMachines: [],
            categories: [{ value: 99, text: 'All' }, { value: 1, text: 'Machine' }, { value: 2, text: 'Line' }, { value: 3, text: 'SMT' }],
            tableStyle: '<meta content="text/html; charset=UTF-8" http-equiv="Content-Type"><meta content="IE=8" http-equiv="X-UA-Compatible"><title>bcl_667529169.htm</title><meta content="BCL easyConverter SDK 5.0.08" name="generator"><style> th, td {width:auto, overflow:hidden;word-wrap:break-word;text-align: center;font-size: 10pt; border: 1px solid black; position: relative; }table{max-width:2490px;width:100%;background-color:white; border-collapse: collapse;}.left{padding:5px; text-align:left}.vertical-text{position: relative;height: 300px;width: 45px;margin-left: 0;padding-right: 10px;writing-mode: tb-rl;-webkit-transform: rotate(180deg);filter: flipv fliph;}.short{height:80px}</style>',
            tableHeader: '<table id="monthlyprdtable" class="highlight-table" border=1; cellspacing=0/>'
                + '<tr>'
                + '<th style = "">Month</th>'
                + '<th style = "">Jan</th>'
                + '<th style = "">Feb</th>'
                + '<th style = "">Mar</th>'
                + '<th style = "">Apr</th>'
                + '<th style = "">May</th>'
                + '<th style = "">Jun</th>'
                + '<th style = "">Jul</th>'
                + '<th style = "">Aug</th>'
                + '<th style = "">Sep</th>'
                + '<th style = "">Oct</th>'
                + '<th style = "">Nov</th>'
                + '<th style = "">Dec</th>'
                + '<th style = "">YTD Average</th>'
                + '</tr>',
            startTime: ['06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '00:00', '01:00', '02:00', '03:00', '04:00', '05:00'],
            endTime: ['18:59', '19:59', '20:59', '21:59', '22:59', '23:59', '00:59', '01:59', '02:59', '03:59', '04:59', '05:59', '06:59', '07:59', '08:59', '09:59', '10:59', '11:59', '12:59', '13:59', '14:59', '15:59', '16:59', '17:59'],
        };
        this.node = React.createRef();
    }

    componentWillMount() {
        let yearArray = [];
        for (let i = this.state.selectedYear; i >= 2019; i--) {
            yearArray.push(i);
            this.setState({
                years: yearArray
            });
        }

        this.setState({
            machines: []
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null)
            return fetch(`${config.apiUrl}/getAllMachines?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(machine => {
                    let data = [],
                        dynamicCategories = [{ text: 'All', value: 99 }];
                    // login successful if there's a user in the response
                    if (machine) {
                        machine.forEach(item => {
                            data.push({ 'id': item.id, 'label': item.machine, 'category': item.category, 'value': item.machine });
                            if (item.description && !dynamicCategories.some(cat => cat.value === item.category)) {
                                dynamicCategories.push({ text: item.description, value: item.category });
                            }
                        })

                        this.setState({ machines: data });
                        this.setState({ originMachines: data });
                        dynamicCategories.length > 1 && this.setState({ categories: dynamicCategories });
                        this.loadMonthlyTargets().then(() => this.buildHtmlTable());
                    }
                    return machine;
                });
    }

    componentDidMount() {
        const node = this.node;
        var ctx = document.getElementById("monthlyPrdchart");
        ctx.style.backgroundColor = 'rgba(53,53,53,255)';
        Chart.defaults.global.defaultFontColor = '#B8B3B3';
        window.monthlyPrdchart = new Chart(node, {
            type: 'bar',
            data: {
                datasets: [
                    {
                        label: 'Average',
                        data: [],
                        borderColor: 'rgba(255, 99, 132, 1)',
                        backgroundColor: 'rgba(255, 99, 132, 1)'
                    },
                    {
                        label: 'Target',
                        data: [],
                        type: 'line',
                        fill: false,
                        borderColor: "rgb(54, 162, 235)"
                    },
                ],
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            },
            options: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        boxWidth: 20,
                        padding: 20,
                        generateLabels: reportChartLegend
                    }
                },
                scales: {
                    xAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: "#FFFFFF3"
                        }

                    }],
                    yAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: "#FFFFFF2"
                        },
                        ticks: {
                            min: 0,
                            max: 100
                        }
                    }]
                },
                title: {
                    display: true,
                    text: ['MONTHLY PRODUCTION PRODUCTIVITY  PERFORMANCE  ( Part Cycle Time)', 'Monthly Target: 0% ']

                },
                plugins: {
                    labels: false
                }
            },
        });
    }

    loadMonthlyTargets = () => {
        const user = localStorage.getItem('user');
        if (!user) return Promise.resolve();
        const accountId = JSON.parse(user).accountId;
        return fetch(`${config.apiUrl}/getAccountTarget?account_id=${accountId}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        })
            .then((res) => (res.ok ? res.json() : null))
            .then((account) => {
                const { oee, productivity } = loadMonthlyTargetsFromAccount(account || {});
                cacheMonthlyTargetsInLocalStorage(oee, productivity);
                const monthTargets = getMonthlyTargetArrayForYear(productivity, this.state.selectedYear);
                const target = getCurrentMonthTarget(productivity, this.state.selectedYear);
                // Wait for the targets before starting the report request.
                return new Promise(resolve => this.setState({ monthTargets, target }, resolve));
            })
            .catch(() => Promise.resolve());
    };

    tdWrap(content, target) {
        let style = '';
        const value = parseFloat(content);
        const numericTarget = parseFloat(target);
        if (value === 0) {
            style = ' style="color: #000000;"';
        } else if (Number.isFinite(value) && Number.isFinite(numericTarget)) {
            style = value >= numericTarget
                ? ' style="color: #28a745;"'
                : ' style="color: #ff0000;"';
        }
        return '<td' + style + '>' + content + '</td>';
    }

    buildHtmlTable() {
        const { tableStyle, tableHeader } = this.state;
        const finalMachines = [];

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ machine: this.state.selectedMachine })
        };
        let query = `/getMachineProductivityByMonth?company=${JSON.parse(localStorage.getItem('user')).accountId}&year=${this.state.selectedYear}&start=${this.state.selectedStartTime}&end=${this.state.selectedEndTime}`;
        if (this.state.selectedCategory != 99) {
            query += `&category=${this.state.selectedCategory}`;
        }
        if (localStorage.getItem('user') != null) {
            return fetch(`${config.apiUrl}${query}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(machine => {
                    let mc = {};
                    let avg = [];
                    let tgt = [];
                    let html = '';
                    const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

                    mc = machine.reduce(function (r, a) {
                        const key = a.Months;
                        r[a.machine] = r[a.machine] || [];
                        r[a.machine][key] = a.avgMc || 0;
                        return r;
                    }, Object.create(null));

                    const monthTargets = this.state.monthTargets.length
                        ? this.state.monthTargets
                        : new Array(12).fill(this.state.target);
                    let countKey = 0;
                    // monthSum[i] = total of non-zero values for month i across machines
                    // monthCnt[i] = number of machines with a non-zero value for month i
                    const monthSum = new Array(12).fill(0);
                    const monthCnt = new Array(12).fill(0);

                    for (let key in mc) {
                        let rowSum = 0, nonZeroMonths = 0;
                        html += '<tr>';
                        html += this.tdWrap(key);
                        months.forEach((m, i) => {
                            const val = parseFloat(mc[key][m]) || 0;
                            html += this.tdWrap(val, monthTargets[i]);
                            if (val) { rowSum += val; nonZeroMonths++; monthSum[i] += val; monthCnt[i]++; }
                        });
                        const rowTargets = monthTargets.filter((t, i) => (parseFloat(mc[key][months[i]]) || 0) > 0);
                        const rowAvgTarget = rowTargets.length
                            ? Math.floor(rowTargets.reduce((sum, t) => sum + parseFloat(t), 0) / rowTargets.length)
                            : monthTargets[0];
                        html += this.tdWrap(nonZeroMonths > 0 ? Math.floor(rowSum / nonZeroMonths) : 0, rowAvgTarget);
                        html += '</tr>';
                        countKey++;
                    }

                    // Average row — divide each month's sum by machines that had non-zero data
                    const monthAvgs = monthSum.map((s, i) => monthCnt[i] > 0 ? parseFloat((s / monthCnt[i]).toFixed(1)) : 0);
                    const nonZeroMonthAvgs = monthAvgs.filter(v => v > 0);
                    const ytdAvg = nonZeroMonthAvgs.length > 0 ? Math.floor(nonZeroMonthAvgs.reduce((a, b) => a + b, 0) / nonZeroMonthAvgs.length) : 0;
                    const ytdTargetAvg = monthTargets.filter((t, i) => monthCnt[i] > 0);
                    const ytdTarget = ytdTargetAvg.length
                        ? Math.floor(ytdTargetAvg.reduce((sum, t) => sum + parseFloat(t), 0) / ytdTargetAvg.length)
                        : monthTargets[0];
                    html += '<tr>';
                    html += this.tdWrap('Average');
                    monthAvgs.forEach((a, i) => { html += this.tdWrap(a, monthTargets[i]); });
                    html += this.tdWrap(ytdAvg, ytdTarget);
                    html += '</tr>';

                    avg = [...monthAvgs];
                    countKey++;

                    //target
                    html += '<tr>';
                    html += this.tdWrap('Target');
                    for (let i = 0; i < 12; i++) {
                        html += this.tdWrap(monthTargets[i]);
                        tgt.push(monthTargets[i]);
                    }
                    const ytdLabelTarget = ytdTargetAvg && ytdTargetAvg.length
                        ? Math.floor(ytdTargetAvg.reduce((sum, t) => sum + parseFloat(t), 0) / ytdTargetAvg.length)
                        : monthTargets[0];
                    html += this.tdWrap(`${ytdLabelTarget}%`);
                    html += '</tr>';
                    let safeHTML = utils.sanitizeVoidTags((tableStyle + tableHeader + html.split('undefined').join(''))
                        .replaceAll('</img>', '')
                        .replaceAll('</input>', '')
                        .replaceAll('</br>', '<br/>')
                        .replaceAll('</hr>', '<hr/>'));
                    this.setState({ table: safeHTML });
                    this.drawChart(avg, tgt);
                    return machine;
                });
        }
    }

    drawChart(m, t) {
        const backgroundColors = m.map((val, index) => (val >= t[index] ? 'rgba(40, 167, 69, 0.8)' : 'rgba(255, 99, 132, 0.8)'));
        const borderColors = m.map((val, index) => (val >= t[index] ? 'rgb(40, 167, 69)' : 'rgb(255, 99, 132)'));
        window.monthlyPrdchart.data.datasets[0].backgroundColor = backgroundColors;
        window.monthlyPrdchart.data.datasets[0].borderColor = borderColors;
        window.monthlyPrdchart.data.datasets[0].data = m;
        window.monthlyPrdchart.data.datasets[1].data = t;
        window.monthlyPrdchart.options.title.text = ['MONTHLY PRODUCTION PRODUCTIVITY  PERFORMANCE  ( Part Cycle Time)', 'Monthly Target: ' + this.state.target + '% '];
        window.monthlyPrdchart.update();

    }

    exportExcel() {
        utils.tableToExcel('datatable', 'Report', 'MonthlyProductivityReport_' + this.state.selectedYear + '.xls');

    };

    optionClicked(optionsList) {
        this.setState({ machines: optionsList });
    }
    selectedBadgeClicked(optionsList) {
        this.setState({ selectedMachine: optionsList });
    }

    filterMachines(categories) {
        let allmachines = [];

        if (categories == 99) {
            this.setState({ machines: this.state.originMachines })
        }
        else {
            for (let i = 0; i < this.state.originMachines.length; i++) {
                if (this.state.originMachines[i].category == categories)
                    allmachines.push({ 'id': this.state.originMachines[i].id, 'label': this.state.originMachines[i].label, 'category': this.state.originMachines[i].category, 'value': this.state.originMachines[i].label });

            }
            this.setState({ machines: allmachines })
        }
    }


    render() {
        const { tableStyle, tableHeader, tableContent } = this.state;
        const selectedOptionsStyles = {
            color: "#3c763d",
            backgroundColor: "#dff0d8"
        };
        const optionsListStyles = {
            backgroundColor: "#dff0d8",
            color: "#3c763d"
        };
        return (
            <div style={{ width: '100%' }}>
                <div className="container" style={{ marginBbottom: '20em', position: 'relative', minHeight: '50px' }}>
                    <Form inline>
                        <FormGroup controlId="formInlineName">
                            <Form.Label>Year:</Form.Label>{' '}
                            <FormControl as="select" placeholder="select"
                                value={this.state.selectedYear} onChange={(e) => {
                                    this.setState({ selectedYear: e.target.value }, () => {
                                        const { productivity } = readCachedMonthlyTargets();
                                        const monthTargets = getMonthlyTargetArrayForYear(productivity, this.state.selectedYear);
                                        this.setState({ monthTargets, target: monthTargets[0] }, () => this.buildHtmlTable());
                                    })
                                }}>
                                <option value="0">select</option>
                                {
                                    this.state.years.map((year) => {
                                        return <option key={year} value={year} >{year}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{' '}
                        <FormGroup controlId="formInlineName">
                            <Form.Label> Category:</Form.Label>{' '}
                            <FormControl as="select" placeholder="select"
                                value={this.state.selectedCategory} onChange={(e) => {
                                    if (e.target.value != 'select') {
                                        this.setState({ selectedCategory: e.target.value });
                                    } else {
                                        delete this.state.selectedCategory;
                                    }
                                    this.filterMachines(e.target.value);

                                }}>
                                <option value="0">select</option>
                                {
                                    this.state.categories.map((category) => {
                                        return <option key={category.value} value={category.value}>{category.text}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{'   '}
                        {this.state.selectedCategory != 99 && <FormGroup controlId="formInlineName">
                            <div class="col-xs-2" style={{ marginTop: '10px' }}>
                                <Form.Label> Items:</Form.Label></div>{' '}
                            <div class="col-xs-10" style={{ minWidth: '200px' }}>
                                <Select
                                    options={this.state.machines}
                                    isMulti
                                    onChange={this.selectedBadgeClicked.bind(this)}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            </div>
                        </FormGroup>}{' '}
                        <FormGroup controlId="formInlineName">
                            <Form.Label>Start Time:</Form.Label>{' '}
                            <FormControl as="select" placeholder="select"
                                value={this.state.selectedStartTime} onChange={(e) => {
                                    if (e.target.value != 'select') {
                                        this.setState({ selectedStartTime: e.target.value });
                                    } else {
                                        delete this.state.selectedStartTime;
                                    }
                                }
                                }>
                                <option value="0">select</option>
                                {
                                    this.state.startTime.map((time) => {
                                        return <option key={time} value={time}>{time}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{' '}
                        <FormGroup controlId="formInlineName">
                            <Form.Label>End Time:</Form.Label>{' '}
                            <FormControl as="select" placeholder="select"
                                value={this.state.selectedEndTime} onChange={(e) => {
                                    if (e.target.value != 'select') {
                                        this.setState({ selectedEndTime: e.target.value });
                                    } else {
                                        delete this.state.selectedEndTime;
                                    }
                                }
                                }>
                                <option value="0">select</option>
                                {
                                    this.state.endTime.map((time) => {
                                        return <option key={time} value={time}>{time}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{' '}
                        <Button
                            bsStyle="primary"
                            style={{ float: "right", margin: 10 }}
                            // disabled={isLoading}
                            // onClick={!isLoading ? this.handleClick : null}
                            onClick={e => this.buildHtmlTable()}>Show</Button>
                    </Form>
                    <canvas id="monthlyPrdchart" width="600" height="200" ref={node => (this.node = node)} style={{ marginTop: '10px' }}></canvas>
                    {this.state.table ? <div style={{ width: "100%" }}><Button
                        bsStyle="primary"
                        style={{ float: "right", margin: 10 }}
                        onClick={e => this.exportExcel()}>Export</Button></div> : ''}
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                <div id="datatable" className="report-sticky-header"
                    style={{ boxSizing: 'border-box', padding: '0 12px', width: '100%' }} dangerouslySetInnerHTML={{ __html: this.state.table }} />
            </div>
        );
    }
}

export { MonthlyProductivityReport };